/**
 * CoordinatePanel
 *
 * Fixed bottom-left panel displaying cursor coordinates in three formats:
 * MGRS, UTM, and Lat/Lng.
 */

import React from 'react'
import {
  latLngToMgrs,
  latLngToUtm,
  formatMgrsDisplay,
} from '../utils/mgrsConvert.js'

/**
 * Format latitude as a display string (e.g. "46.7867 N").
 */
function formatLat(lat) {
  const dir = lat >= 0 ? 'N' : 'S'
  return `${Math.abs(lat).toFixed(4)}\u00B0${dir}`
}

/**
 * Format longitude as a display string (e.g. "92.1005 W").
 */
function formatLng(lng) {
  const dir = lng >= 0 ? 'E' : 'W'
  return `${Math.abs(lng).toFixed(4)}\u00B0${dir}`
}

/**
 * @param {{ lat: number|null, lng: number|null }} props
 */
export function CoordinatePanel({ lat, lng }) {
  const hasCoords = lat != null && lng != null

  let mgrsDisplay = '---'
  let utmDisplay = '---'
  let latlngDisplay = '---'

  if (hasCoords) {
    try {
      const mgrsStr = latLngToMgrs(lat, lng, 3)
      mgrsDisplay = formatMgrsDisplay(mgrsStr)
    } catch {
      mgrsDisplay = 'N/A'
    }

    try {
      const utm = latLngToUtm(lat, lng)
      utmDisplay = `${utm.zone}${utm.letter} ${utm.easting}E ${utm.northing}N`
    } catch {
      utmDisplay = 'N/A'
    }

    latlngDisplay = `${formatLat(lat)}, ${formatLng(lng)}`
  }

  return (
    <div className="coordinate-panel">
      <div className="coord-row">
        <span className="coord-label">MGRS</span>
        <span className="coord-value mgrs-text">{mgrsDisplay}</span>
      </div>
      <div className="coord-row">
        <span className="coord-label">UTM</span>
        <span className="coord-value">{utmDisplay}</span>
      </div>
      <div className="coord-row">
        <span className="coord-label">Lat/Lng</span>
        <span className="coord-value">{latlngDisplay}</span>
      </div>
    </div>
  )
}

export default CoordinatePanel
